module.exports = ".modal-form-timeline-disabled {\r\n    pointer-events: none;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/modal/client-detail/timeline/modal-form-timeline-top/modal-form-timeline-top.component.css
// module id = ./src/app/app_manager/modal/client-detail/timeline/modal-form-timeline-top/modal-form-timeline-top.component.css
// module chunks = main